import api from "./api";

const validacaoService = {
  validarLicenca: async (solicitacaoDeLicencaId) => {
    try {
      const response = await api.get(
        `/LicencaEmitida/validar/${solicitacaoDeLicencaId}`
      );
      return response.data?.data || null;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw error.response?.data || { message: "Erro ao validar licença." };
    }
  },

  validarAutorizacao: async (solicitacaoDeAutorizacaoId) => {
    try {
      const response = await api.get(
        `/AutorizacaoEmitida/validar/${solicitacaoDeAutorizacaoId}`
      );
      return response.data?.data || null;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw error.response?.data || { message: "Erro ao validar autorização." };
    }
  },

  validarCdnslam: async (empreendimentoId) => {
    try {
      const response = await api.get(`/CDNSLAM/validar/${empreendimentoId}`);
      return response.data?.data || null;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw error.response?.data || { message: "Erro ao validar CDNSLAM." };
    }
  },

  validarIsencao: async (isencaoId) => {
    try {
      const response = await api.get(
        `/IsencaoLicenciamentoConsulta/validar/${isencaoId}`
      );
      return response.data?.data || null;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw (
        error.response?.data || {
          message: "Erro ao validar isenção de licenciamento.",
        }
      );
    }
  },
};

export default validacaoService;
